// @flow
import {fromJS} from 'immutable';
import {Store} from 'client/framework';
import {resource} from '@albert-io/json-api-framework/request/builder';
import assignmentSettingsEditorActions from './AssignmentSettingsEditor.actions';
import {invalidatePartialInterest} from 'resources/mandark.resource';
import type {AssignmentModelV3} from 'resources/augmented/Assignment/AssignmentModel.v3';

export default class AssignmentSettingsEditorStore extends Store {
  constructor(name: string) {
    super(name);
    this.setInitialData(
      fromJS({
        assignment: null,
        originalAssignment: null,
        saveAssignmentPromise: null
      })
    );
    this.handleTargeted(assignmentSettingsEditorActions.INITIALIZE, this._initialize);
    this.handleTargeted(assignmentSettingsEditorActions.RESET_STORE, this.resetStore);
    this.handleTargeted(assignmentSettingsEditorActions.SAVE_ASSIGNMENT, this._saveAssignment);
    this.handleTargeted(assignmentSettingsEditorActions.UPDATE_FIELD, this._updateField);
  }

  async _initialize(assignmentId: string): Promise<*> {
    const assignment = await resource('assignment_v3')
      .mandarkEndpoint(['assignments_v3', assignmentId])
      .include('sections_v1.question_sets_v1.questions_v1')
      .include('question_sets_v1.questions_v1')
      .getResourcePromise();
    this.writeData((store) =>
      store.set('assignment', assignment).set('originalAssignment', assignment)
    );
  }

  _updateField({setter, value}: {setter: string, value: *}) {
    const updatedAssignment = this.getAssignment()[setter](value);
    this.writeData('assignment', updatedAssignment);
  }

  _saveAssignment() {
    const saveAssignmentPromise = this.getAssignment().save();
    this.writeData('saveAssignmentPromise', saveAssignmentPromise);
    saveAssignmentPromise.then(() => {
      invalidatePartialInterest({resourcePath: ['assignment_v3']});
    });
  }

  getAssignment = (): AssignmentModelV3 => this.readData('assignment');

  getOriginalAssignment = (): AssignmentModelV3 => this.readData('originalAssignment');

  getSaveAssignmentPromise = (): Promise<*> => this.readData('saveAssignmentPromise');
}
